Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-product-compare-box', function (envelope) {

        var $context = envelope.message.data.context,
            $boxes = $('.x-product-compare-box', $context);

        if ($boxes.length < 1)
            return;

        $boxes.on('click', '.js-add-to-cart', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $box, $qty,
                id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems;

            if ($this.hasClass('x-disabled') || $this.is(':disabled'))
                return;

            $box = $this.closest('.x-product-compare-box');
            $qty = $('.js-quantity', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            path = $box.data('path');
            qty = $qty.val() || 1;
            extraAttributes = [];
            bundleItems = [];
            recipeItems = [];
            comboItems = [];

            var itemInfo = {
                minQuantity: parseInt($box.data('min-quantity') || 0),
                maxQuantity: parseInt($box.data('max-quantity') || 0),
                quanta: parseInt($box.data('quanta') || 0)
            };

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Cart.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems, recipeItems, comboItems, itemInfo));
            if ($('.x-productcompare-widget').data('template') === 1) {
                //Open the widget only for template 1 of Compare Widget
                Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.CartWidget, false));
            }
        });

        $boxes.on('click', '.js-add-to-wishlist', function (e) {           
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $box, $qty,
                id, skuId, path, qty, extraAttributes, bundleItems;

            $box = $this.closest('.x-product-compare-box');
            $qty = $('.js-quantity', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            path = $box.data('path');
            qty = $qty.val() || 1;
            extraAttributes = [];
            bundleItems = [];

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Wishlist.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems));
            if ($('.x-productcompare-widget').data('template') === 1) {
                //Open the widget only for template 1 of Compare Widget
                Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.WishlistWidget, false));
            }
        });

        $boxes.on('click', '.js-remove', function (e) {
            e.preventDefault();

            var $this = $(this);
            var $item = $this.closest('.x-product-compare-box');
            var id = $item.data('productid');

            Vendd.MessageBus.publishAsync($item, new Vendd.ProductCompare.Messages.Remove(id));
            if ($('.x-productcompare-widget').data('template') === 1) {
                //Open the widget only for template 1 of Compare Widget
                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.ProductCompareWidget, false));
            }
        });
    });
});